function getOperatingSystem() {
  const userAgent = navigator.userAgent;

  if (/Win/i.test(userAgent)) {
    return { osCode: "01", osName: "Windows" };
  } else if (/Mac/i.test(userAgent)) {
    return { osCode: "02", osName: "Macintosh" };
  } else if (/Linux/i.test(userAgent)) {
    return { osCode: "03", osName: "Linux" };
  } else if (/Android/i.test(userAgent)) {
    return { osCode: "04", osName: "Android" };
  } else if (/iPad|iPhone|iPod/i.test(userAgent)) {
    return { osCode: "04", osName: "iOS" };
  } else {
    return { osCode: "00", osName: "Unknown Operating System" };
  }
}

module.exports = {
  getOperatingSystem,
};
